package com.partejar.app.core.di

import com.partejar.app.core.network.ApiConfig
import com.partejar.app.core.network.SessionRefreshCoordinator
import com.partejar.app.core.network.createHttpClient
import org.koin.dsl.module
import com.partejar.app.core.address.CepDataSource
import com.partejar.app.core.address.ViaCepDataSource
import com.partejar.app.core.address.createCepHttpClient

const val PRODUCTION_API_BASE_URL = "https://partejar-api-production.apps.yanox.io"

fun networkModule(baseUrl: String) = module {
    single {
        ApiConfig(baseUrl)
    }
    single { SessionRefreshCoordinator(get(), get(), get(), get()) }
    single { createHttpClient(get(), get()) }
    single<CepDataSource> { ViaCepDataSource(createCepHttpClient()) }
}
